import React, { useEffect, useState } from 'react';
import { OperationListStyle } from './OperationListView.styles';
import OperationListHeader from './OperationListHeader';
import { useStowageStore } from 'src/context/StowageContext';
import { useRotationStore } from 'src/context/RotationContext';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import { INITIAL_OPERATION_LIST_COLUMNS } from './OperationlistConstants';
import TransitOperationsList from './transitOperations/OperationListTransitOperations';
import OperationListBerthCallsComponent from './berthCalls/OperationListBerthCalls';
import FilteredOperationList from './operations/FilteredOperationList';
import { getBerthCalls } from 'src/utils/stowage/stowageRotationUtils';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';

const OperationListContentComponent: React.FC = () => {
    const {
        activeOperationsFilters,
        operationListColumns,
        setOperationListColumns,
        operationListSortColumn,
        isOperationListSortDesc,
        activeStowagePlan,
        setBerthOperationListContextMenuState,
    } = useStowageStore();
    const { selectedStowageRotationPortCall, selectedStowageRotationBerthCall } = useRotationStore();
    const [transitOperations, setTransitOperations] = useState<RotationCargoOperation[]>([]);

    useEffect(() => {
        const operationListColumns_ls = localStorage.getItem('operationListColumns');
        if (operationListColumns_ls) {
            setOperationListColumns(JSON.parse(operationListColumns_ls));
        } else if (!operationListColumns) {
            setOperationListColumns({ ...INITIAL_OPERATION_LIST_COLUMNS });
        }
    }, []);

    useEffect(() => {
        if (selectedStowageRotationPortCall) {
            const showTransitOperations = activeOperationsFilters.includes('transit'.toLowerCase());
            if (showTransitOperations) {
                const _transitOperations = activeStowagePlan.transitOperations
                    .filter((transitPortCall) => transitPortCall.portCallGuid === selectedStowageRotationPortCall.portCallGuid)
                    .flatMap((transitPortCall) => transitPortCall.berthCalls[0]?.cargoOperations ?? [])
                    .filter(Boolean);

                setTransitOperations(_transitOperations);
            } else {
                setTransitOperations([]);
            }
        } else if (transitOperations?.length > 0) {
            setTransitOperations([]);
        }
    }, [activeOperationsFilters, selectedStowageRotationPortCall, activeStowagePlan]);

    // Menu handlers
    const handleOpenBerthOperationMenu = (e: React.MouseEvent, berthCall: RotationBerthCall) => {
        e.preventDefault();
        e.stopPropagation();

        const menuYPos = calculateMenuPosition(e);

        setBerthOperationListContextMenuState({
            visible: true,
            tank: null,
            cargoContents: [],
            cargoOperationGuid: crypto.randomUUID(),
            berthCall: berthCall,
            x: 35,
            y: menuYPos,
            violations: null,
        });
    };

    // Calculation methods
    const calculateMenuPosition = (e: React.MouseEvent): number => {
        const windowHeight = window.innerHeight;

        let operationsMenuYpos = 0;

        if (e.screenY > windowHeight) {
            operationsMenuYpos = -100;
        }

        return operationsMenuYpos;
    };

    return (
        <OperationListStyle>
            <OperationListHeader />
            {activeOperationsFilters && !selectedStowageRotationBerthCall && selectedStowageRotationPortCall && (
                <>
                    <OperationListBerthCallsComponent
                        berthCalls={getBerthCalls(selectedStowageRotationPortCall)}
                        selectedStowageRotationPortCall={selectedStowageRotationPortCall}
                        onOpenBerthOperationMenu={(e, berthCall: RotationBerthCall) => {
                            handleOpenBerthOperationMenu(e, berthCall);
                        }}
                    />
                    {transitOperations?.length > 0 && (
                        <TransitOperationsList
                            operations={transitOperations}
                            operationListSortColumn={operationListSortColumn}
                            isOperationListSortDesc={isOperationListSortDesc}
                            activeStowagePlan={activeStowagePlan}
                        />
                    )}
                </>
            )}
            {activeOperationsFilters && selectedStowageRotationBerthCall?.cargoOperations && (
                <FilteredOperationList operations={selectedStowageRotationBerthCall.cargoOperations} filters={activeOperationsFilters} />
            )}
        </OperationListStyle>
    );
};

export default OperationListContentComponent;
